export enum ScoutReceiptDeletionReason {
  Duplicate = 'duplicate',
  NotReceipt = 'not_receipt',
  Other = 'other',
}
